<div>
  <div>
    <mat-toolbar>
      <div class="lblhearder">
        <mat-label>
          Adjust Accruals
        </mat-label>
      </div>
    </mat-toolbar>
  </div>
  <div>
    <mat-card appearance="outlined">
      <div class="row">
        <form [formGroup]="adjustAccrualsForm" class="form-width">          
          <mat-form-field appearance="fill" class="col-md-6">
            <mat-label>Program to Adjust</mat-label>
            <input type="text" placeholder="Search Programs" aria-label="Number" matInput
              [matAutocomplete]="targetProgram" formControlName="TargetProgram"
              (ngModelChange)="onTargetProgramSelection();">
            <mat-autocomplete #targetProgram="matAutocomplete">
              <mat-option class="multipleLine"
                *ngFor="let StandardProgramDetailsOption of filteredStandardProgramDetails | async"
                [value]="StandardProgramDetailsOption.shortName">
                {{StandardProgramDetailsOption.shortName}}<br>
                <p>{{StandardProgramDetailsOption.programCode}}</p>
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="f.TargetProgram.errors && f.TargetProgram.errors.required">
              Program is required!</mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-md-3">
            <mat-label>Current Total Exposure</mat-label>
            <input matInput [value]="targetTotalExposure | currency:'USD':'symbol':'1.0-0'" readonly>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-md-3">
            <mat-label>Requested Total Exposure</mat-label>
            <input matInput [value]="requestedTotalExposure | currency:'USD':'symbol':'1.0-0'" formControlName="RequestedTotalExposure" [(ngModel)]="requestedTotalExposure">
          </mat-form-field>
        </form>
        <div>
          <button mat-raised-button class="functional-button" [disabled]="!adjustAccrualsForm.valid"
            (click)="adjustAccrualRates();">Adjust Accruals</button>
        </div>
      </div>

    </mat-card>
  </div>
  <ngx-spinner class="spinner" size="default" type="ball-spin-clockwise">
    <p>Please Wait.</p>
  </ngx-spinner>
</div>
